export default {
  state: {
    data: [],
    isLoaded: false
  },
  getters: {
    data (state) {
      if (state.isLoaded) {
        return state.data
      } else {
        return false
      }
    },
    combinedData (state, getters, rootState, rootGetters) {
      return rootGetters['combined/data']
    }
  },
  mutations: {
    loadSuccess (state) {
      state.isLoaded = true
      console.log('Mutation: chargerList/loadSuccess')
    },
    storeData (state, payload) {
      state.data = payload
      console.log('Mutation: chargerList/storeData')
    }
  },
  actions: {
    buildList (context) {
      console.log('Action: chargerList/buildList')
      if (!context.state.isLoaded) {
        const data = buildListItems(context)
        if (data) {
          context.commit('storeData', data)
          context.commit('loadSuccess')
        }
      }
    }
  },
  namespaced: true
}

function buildListItems (context) {
  // Create array to store data
  const items = []
  // Get combined data
  const combinedData = context.getters.combinedData.features
  // Only proceed if data is available
  if (combinedData) {
    // Process evroam Data
    combinedData.forEach((data) => {
      const include = (
        // All stations that are at least medium speed (if speed known)
        data.properties.atLeastMedium ||
        (
          // Or chagenet chargers may have unknown speed if under construction / planned
          data.properties.source === 'chargenet' &&
          (
            data.properties.installationStatus === 'Future' ||
            data.properties.installationStatus === 'Under Construction'
          )
        )
      )
      if (include) {
        // For each site, extract relevant details
        const properties = {
          ...data.properties
        }
        // Add extra properties
        properties.stationRating = stationRating(properties.stations)
        properties.lat = data.geometry.coordinates[1]
        properties.long = data.geometry.coordinates[0]
        properties.connectors = stationConnector(properties.stations)
        properties.address = parseAddress(properties.address)
        properties.firstDateFirstOperational = dateFirstOperational(properties.stations)
        if (properties.type !== 'slow') {
          items.push(properties)
        }
      }
    })
  } else {
    // Combined data not yet loaded
    return false
  }

  // Sort items North to South
  items.sort((a, b) => {
    return b.lat - a.lat
  })
  return items
}

function stationRating (stations) {
  let stationString = ''
  stations.forEach((station, index) => {
    if (station.kwRated) {
      if (index === 0) {
        stationString = stationString + station.kwRated + 'kW'
      } else {
        stationString = stationString + ', ' + station.kwRated + 'kW'
      }
    }
  })
  return stationString
}

function stationConnector (stations) {
  // Extact type and number of connectors
  const connectors = {}
  for (const station of stations) {
    station.connectors.forEach((connector, index) => {
      if (connectors[connector.connectorType]) {
        connectors[connector.connectorType] += 1
      } else {
        connectors[connector.connectorType] = 1
      }
    })
  }
  // Convert connectors object into string
  let connectorString = ''
  let index = 0
  const maxIndex = Object.keys(connectors).length - 1
  for (const connector in connectors) {
    if (connectors[connector] === 1) {
      connectorString += connector
    } else {
      connectorString = connectorString + connector + ' (' + connectors[connector] + ')'
    }

    if (maxIndex > 0 && index < maxIndex) {
      connectorString += ' & '
    }
    index += 1
  }
  return connectorString
}

function parseAddress (address) {
  if (address) {
    // Issue is that some strings do not have a space after each comma
    // Extract sub-strings separated by comma
    const subStrings = address.split(',')
    // Remove "NZ" or "New Zealand" if last item
    const lastString = subStrings[subStrings.length - 1].trim()
    if (lastString === 'NZ' || lastString === 'New Zealand') {
      subStrings.pop()
    }
    // Add space after comma and recompile string
    let result = ''
    subStrings.forEach((sub, index) => {
      if (index === 0) {
        result += sub
      } else if (index < subStrings.length) {
        result += ', ' + sub
      }
    })
    return result
  } else {
    return null
  }
}

function dateFirstOperational (stations) {
  const dates = []
  for (const station of stations) {
    if (station.dateFirstOperational) {
      dates.push(station.dateFirstOperational)
    }
  }
  dates.sort()
  return dates[0]
}
